import React, { useMemo, useState, useEffect } from 'react';
import { api } from '../utils/api';
import './PromoBanner.css';

const PromoBanner = ({ onShowPromotions }) => {
  const [promoBanner, setPromoBanner] = useState({
    title: 'Our Black November sale continues!',
    subtitle: 'Coming soon - even more deals',
    countdownDate: '2024-11-29T00:00:00',
    isActive: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPromoBanner();
  }, []);

  const fetchPromoBanner = async () => {
    try {
      setLoading(true);
      const response = await api.get('/content/promo-banner');
      let promoData = null;
      
      // Handle different response formats
      if (response.data) {
        promoData = response.data;
      } else if (response.title) {
        promoData = response;
      }

      if (promoData) {
        setPromoBanner({
          title: promoData.title || 'Our Black November sale continues!',
          subtitle: promoData.subtitle || 'Coming soon - even more deals',
          countdownDate: promoData.countdownDate || '2024-11-29T00:00:00',
          isActive: promoData.isActive !== false
        });
      }
    } catch (error) {
      console.error('Error fetching promo banner:', error);
      // Keep default values on error
    } finally {
      setLoading(false);
    }
  };

  const countdownLabel = useMemo(() => {
    if (!promoBanner.countdownDate) return 'Live now';
    
    const targetDate = new Date(promoBanner.countdownDate);
    const now = new Date();
    const diff = targetDate - now;
    if (diff <= 0) {
      return 'Live now';
    }
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return `${days} day${days !== 1 ? 's' : ''}`;
  }, [promoBanner.countdownDate]);

  // Don't render if not active
  if (!promoBanner.isActive || loading) {
    return null;
  }

  return (
    <div className="promo-banner-wrapper">
      <button
        type="button"
        className="promo-banner"
        onClick={onShowPromotions}
      >
        <div className="promo-banner-text">
          <span className="promo-banner-title">{promoBanner.title}</span>
          {promoBanner.subtitle && (
            <span className="promo-banner-subtitle">{promoBanner.subtitle}</span>
          )}
        </div>
        {promoBanner.countdownDate && (
          <div className="promo-banner-countdown">
            <span className="promo-banner-label">Black Friday starts in</span>
            <span className="promo-banner-badge">{countdownLabel}</span>
            <span className="promo-banner-arrow" aria-hidden="true">→</span>
          </div>
        )}
      </button>
    </div>
  );
};

export default PromoBanner;

